import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import { syncManager } from "./lib/services/sync-manager";
import { queryClient } from "./lib/queryClient";

// Iniciar auto-sync del syncManager (escucha evento online del navegador)
syncManager.startAutoSync();

// Refetchear queries activas al completar sincronización
syncManager.on((event) => {
  if (event.type === "sync:complete") {
    queryClient.refetchQueries({ type: "active" });
  }
});


createRoot(document.getElementById("root")!).render(<App />);
